import React, { Component } from "react";
import { Confirm } from "semantic-ui-react";
import { translate } from "react-i18next";

class ConfirmationModal extends Component {

  render() {
    return (
      <div>
        <Confirm
          open={this.props.open}
          content={this.props.msgContent||this.props.t("message")}
          cancelButton={this.props.t("cancel")}
          confirmButton={this.props.t("ok")}
          onCancel={this.props.handleCancel}
          onConfirm={this.props.handleConfirm}
        />
      </div>
    );
  }
}

export default translate('user_table')(ConfirmationModal);
